import { useEffect, useState } from "react";

export default function useIsApiTakingTime() {
  const [isSlow, setIsSlow] = useState(false);

  useEffect(() => {
    const start = () => setIsSlow(true);

    window.addEventListener("slow-response-start", start);

    return () => {
      window.removeEventListener("slow-response-start", start);
    };
  }, []);

  return {isSlow, setIsSlow};
}
